import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasParticipantSchema = withDefaults({
  type: 'tas-participant',
  objectExtensions: ['tas-participant'],
  fields: [
    {
      kind: 'attribute',
      name: 'payrollId',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'serviceData',
    },
    {
      kind: 'attribute',
      name: 'employmentStartDate',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'attribute',
      name: 'eligibilityStrategy',
    },
    {
      kind: 'hasMany',
      name: 'tasEligibilities',
      type: 'tas-eligibility',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'tasGroupings',
      type: 'tas-grouping',
      options: {
        async: false,
        inverse: 'tasProgramTemplate',
        as: 'tas-program-template',
      },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: 'tasParticipant',
      },
    },
    {
      kind: 'belongsTo',
      name: 'supervisor',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'departmentHead',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default TasParticipantSchema;
